module.exports = __webpack_public_path__ + "TiemposFine-Black.svg?898b79ce7bc1931a6cda26d0f74a603b";